module.exports = __webpack_public_path__ + "static/media/bdphand.e748f6f4.png";